import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../App';
import { templateApi } from '../services/api';

function OnboardingGatekeeper({ children }) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [checking, setChecking] = useState(true);
    const [shouldRedirect, setShouldRedirect] = useState(false);

    useEffect(() => {
        const checkStatus = async () => {
            // Only Admins need to go through the manifesto/first-template flow
            if (user?.role !== 'admin') {
                console.log('[Gatekeeper] Non-admin user, allowing access');
                setChecking(false);
                return;
            }

            // Allow access to onboarding routes to prevent infinite loops
            if (location.pathname.startsWith('/onboarding')) {
                console.log('[Gatekeeper] Already on onboarding route, allowing access');
                setChecking(false);
                return;
            }

            try {
                console.log('[Gatekeeper] Checking templates for admin user...');
                // Fetch ALL templates (since we are admin)
                const data = await templateApi.list();
                const templates = data.templates || [];

                console.log('[Gatekeeper] Templates found:', templates.length);

                if (templates.length === 0) {
                    console.log('[Gatekeeper] No templates found. Enforcing onboarding.');
                    setShouldRedirect(true);
                } else {
                    console.log('[Gatekeeper] Templates exist, allowing access to main app');
                }
            } catch (err) {
                console.error('[Gatekeeper] Failed to check templates:', err);
                console.error('[Gatekeeper] Error details:', {
                    message: err.message,
                    status: err.status || 'unknown'
                });
                
                // FAIL CLOSED: If we can't check templates, assume no templates exist
                // This enforces the onboarding flow even if there's an API error
                console.log('[Gatekeeper] API error - failing closed, enforcing onboarding');
                setShouldRedirect(true);
            } finally {
                setChecking(false);
            }
        };

        if (user) {
            checkStatus();
        } else {
            setChecking(false);
        }
    }, [user, location.pathname]);

    // Handle redirect after state is set
    useEffect(() => {
        if (shouldRedirect && !checking) {
            console.log('[Gatekeeper] Redirecting to onboarding...');
            navigate('/onboarding');
        }
    }, [shouldRedirect, checking, navigate]);

    if (checking) {
        // Simple loading state while we verify
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div className="spinner"></div>
                <div style={{ marginLeft: '1rem', color: '#666' }}>
                    Checking workspace status...
                </div>
            </div>
        );
    }

    return children;
}

export default OnboardingGatekeeper;
